var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"p-0",attrs:{"fluid":"","fill-height":""}},[_c('v-row',{staticClass:"background-container",attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"12","md":"8","sm":"6","xs":"4"}},[_c('sign-in')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }